/*
 * @Author: ttheitao
 * @Date: 2024-03-29 10:38:50
 * @Description: some description
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-08-20 20:00:41
 */
/* eslint-disable */

import Database from '@/lib/Database';
import { IKeyValue } from '@/lib/IType';
import Util from '@/lib/Util';
import http from '@/lib/http';
import { user } from '../store/user';
import { refresh } from '@/store/bookmarks';

const urlPrefix = 'onetab/';

/**
 * @description: 获取所有书签
 * @return {*}
 */
export const getBookmarks = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tx = Database.db.transaction(
      Database.storeNames.bookmarks,
      'readonly'
    );
    const store = tx.objectStore(Database.storeNames.bookmarks);
    const request = store.getAll();
    request.addEventListener('success', (e: any) => {
      resolve(e.target.result);
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 新增书签
 * @param {object} data
 * @return {*}
 */
export const addBookmark = (data: IKeyValue, isSync = true): Promise<any> => {
  return new Promise((resolve, reject) => {
    const store = Database.db
      .transaction(Database.storeNames.bookmarks, 'readwrite')
      .objectStore(Database.storeNames.bookmarks);
    const temp = {
      uuid: `bm${Util.generateUUID(20).toLowerCase()}`,
      ...data,
    };
    const request = store.add(temp);

    request.addEventListener('success', (e: any) => {
      // 本地新增成功则视为完成操作，如未登录或网络问题，则下次同步
      resolve(temp);
      isSync && syncToServer();
      // if (!user.token) return;

      // http
      //   .post(`${urlPrefix}bookmarks`, temp)
      //   .then((res) => {
      //     // TODO 同步结果通知
      //     // console.log('addBookmark', res);
      //   })
      //   .catch((err) => {
      //     // TODO 同步结果通知
      //     // console.warn('addBookmark', err);
      //   });
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 修改书签
 * @param {string} uuid
 * @param {object} data
 * @return {*}
 */
export const putBookmark = (
  uuid: string,
  data: IKeyValue,
  isSync = true
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const store = Database.db
      .transaction(Database.storeNames.bookmarks, 'readwrite')
      .objectStore(Database.storeNames.bookmarks);
    const request = store.get(uuid);
    request.addEventListener('success', (e: any) => {
      const oldData = e.target.result;
      for (const key in data) {
        oldData[key] = data[key];
      }
      const requestUpdate = store.put(oldData);
      requestUpdate.addEventListener('success', (e: any) => {
        resolve(oldData);
        isSync && syncToServer();
        // if (!user.token || !needSyncServer) return;

        // http
        //   .post(`${urlPrefix}bookmarks`, oldData)
        //   .then((res) => {
        //     // TODO 同步结果通知
        //     // console.log('putBookmark', res);
        //   })
        //   .catch((err) => {
        //     // TODO 同步结果通知
        //     // console.warn('putBookmark', err);
        //   });
      });
      requestUpdate.addEventListener('error', (e: any) => {
        reject(e);
      });
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 删除书签
 * @param {string} uuid
 * @return {*}
 */
export const delBookmark = (uuid: string, isSync = true): Promise<any> => {
  return new Promise((resolve, reject) => {
    const request = Database.db
      .transaction(Database.storeNames.bookmarks, 'readwrite')
      .objectStore(Database.storeNames.bookmarks)
      .delete(uuid);

    request.addEventListener('success', (e: any) => {
      resolve(e);
      isSync && syncToServer();

      // if (!user.token) return;

      // http
      //   .delete(`${urlPrefix}bookmarks/${uuid}`)
      //   .then((res) => {
      //     console.log('del remote bookmark success', res);
      //   })
      //   .catch((err) => {
      //     const logStore = Database.db
      //       .transaction(Database.storeNames.logs, 'readwrite')
      //       .objectStore(Database.storeNames.logs);
      //     const logRequest = logStore.get('deleteBmArr');
      //     logRequest.onsuccess = (e: any) => {
      //       const deleteBmArr = e.target.result ? e.target.result.data : [];
      //       deleteBmArr.push(uuid);
      //       logStore.put({
      //         type: 'deleteBmArr',
      //         data: deleteBmArr,
      //       });
      //     };
      //     console.warn('delremote bookmark error', err);
      //   });
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 获取所有分类
 * @return {*}
 */
export const getCategories = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tx = Database.db?.transaction(
      Database.storeNames.categories,
      'readonly'
    );
    const store = tx?.objectStore(Database.storeNames.categories);
    const request = store?.getAll();
    request.addEventListener('success', (e: any) => {
      resolve(e.target.result);
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 新增分类
 * @param {object} data
 * @return {*}
 */
export const addCategory = (data: IKeyValue, isSync = true): Promise<any> => {
  return new Promise((resolve, reject) => {
    const store = Database.db
      .transaction(Database.storeNames.categories, 'readwrite')
      .objectStore(Database.storeNames.categories);
    const temp = {
      uuid: `cat${Util.generateUUID(20).toLowerCase()}`,
      ...data,
    };
    const request = store.add(temp);
    request.addEventListener('success', (e: any) => {
      resolve(temp);
      isSync && syncToServer();
      // if (!user.token && !isSync) return;

      // http
      //   .post(`${urlPrefix}categories`, temp)
      //   .then((res) => {
      //     // TODO 同步结果通知
      //     // console.log('addCategory', res);
      //   })
      //   .catch((err) => {
      //     // TODO 同步结果通知
      //     // console.warn('addCategory', err);
      //   });
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};
export const addRemoteCategory = (data: IKeyValue): Promise<any> => {
  return new Promise((resolve, reject) => {
    const store = Database.db
      .transaction(Database.storeNames.categories, 'readwrite')
      .objectStore(Database.storeNames.categories);
    const temp = {
      uuid: `cat${Util.generateUUID(20).toLowerCase()}`,
      ...data,
    };
    const request = store.add(temp);
    request.addEventListener('success', (e: any) => {
      if (!user.token) return;
      http
        .post(`${urlPrefix}categories`, temp)
        .then((res) => {
          if (res.data.code === 200) {
            resolve(res.data.data);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 修改分类
 * @param {string} uuid
 * @param {object} data
 * @return {*}
 */
export const putCategory = (
  uuid: string,
  data: IKeyValue,
  isSync = true
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const store = Database.db
      .transaction(Database.storeNames.categories, 'readwrite')
      .objectStore(Database.storeNames.categories);
    const request = store.get(uuid);
    request.addEventListener('success', (e: any) => {
      const oldData = e.target.result;
      for (const key in data) {
        oldData[key] = data[key];
      }
      const requestUpdate = store.put(oldData);
      requestUpdate.addEventListener('success', (e: any) => {
        resolve(oldData);
        isSync && syncToServer();
        // if (!user.token) return;

        // http
        //   .post(`${urlPrefix}categories`, oldData)
        //   .then((res) => {
        //     // TODO 同步结果通知
        //     // console.log('putCategory', res);
        //   })
        //   .catch((err) => {
        //     // TODO 同步结果通知
        //     // console.warn('putCategory', err);
        //   });
      });
      requestUpdate.addEventListener('error', (e: any) => {
        reject(e);
      });
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};
export const putRemoteCategory = (
  uuid: string,
  data: IKeyValue
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const store = Database.db
      .transaction(Database.storeNames.categories, 'readwrite')
      .objectStore(Database.storeNames.categories);
    const request = store.get(uuid);
    request.addEventListener('success', (e: any) => {
      const oldData = e.target.result;
      for (const key in data) {
        oldData[key] = data[key];
      }
      const requestUpdate = store.put(oldData);
      requestUpdate.addEventListener('success', (e: any) => {
        if (!user.token) return;

        http
          .post(`${urlPrefix}categories`, oldData)
          .then((res) => {
            if (res.data.code === 200) {
              resolve(res.data.data);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
      requestUpdate.addEventListener('error', (e: any) => {
        reject(e);
      });
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 删除分类
 * @param {string} uuid
 * @return {*}
 */
export const delCategory = (uuid: string, isSync = true): Promise<any> => {
  return new Promise((resolve, reject) => {
    const request = Database.db
      .transaction(Database.storeNames.categories, 'readwrite')
      .objectStore(Database.storeNames.categories)
      .delete(uuid);

    request.addEventListener('success', (e: any) => {
      resolve(e);
      isSync && syncToServer();
      // if (!user.token) return;

      // http
      //   .delete(`${urlPrefix}categories/${uuid}`)
      //   .then((res) => {
      //     console.log('del remote category success', res);
      //   })
      //   .catch((err) => {
      //     const logStore = Database.db
      //       .transaction(Database.storeNames.logs, 'readwrite')
      //       .objectStore(Database.storeNames.logs);
      //     const logRequest = logStore.get('deleteCatArr');
      //     logRequest.onsuccess = (e: any) => {
      //       const deleteCatArr = e.target.result ? e.target.result.data : [];
      //       deleteCatArr.push(uuid);
      //       logStore.put({
      //         type: 'deleteCatArr',
      //         data: deleteCatArr,
      //       });
      //     };
      //     console.warn('del remote category error', err);
      //   });
    });

    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 获取日志
 * @param {string} type 主键key
 * @return {*}
 */
export const getLog = (type: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    const request = Database.db
      .transaction(Database.storeNames.logs, 'readonly')
      .objectStore(Database.storeNames.logs)
      .get(type);
    request.addEventListener('success', (e: any) => {
      resolve(e.target.result);
    });
    request.addEventListener('error', (e: any) => {
      reject(e);
    });
  });
};

/**
 * @description: 将数据同步到本地
 * @return {*}
 */
export const syncToLocal = () => {
  return new Promise(async (resolve, reject) => {
    if (!user.token) {
      reject({ msg: '登录后同步' });
      return;
    }

    console.log('syncToLocal');
    http
      .get(`${urlPrefix}categories`)
      .then(async (res) => {
        if (res.data.code !== 200) {
          reject(res.data.msg);
          return;
        }

        const tx = Database.db.transaction(
          [
            Database.storeNames.categories,
            Database.storeNames.bookmarks,
            Database.storeNames.logs,
          ],
          'readwrite'
        );

        let remoteCategories = res.data.data as unknown as Array<IKeyValue>;
        remoteCategories = remoteCategories ?? [];

        if (remoteCategories.length) {
          tx.objectStore(Database.storeNames.bookmarks).clear();
          tx.objectStore(Database.storeNames.categories).clear();
          tx.objectStore(Database.storeNames.logs).clear();
        }

        for (let i in remoteCategories) {
          const category = remoteCategories[i];
          await addCategory(category, false);

          if (Array.isArray(category.bookmarks)) {
            for (let j in category.bookmarks) {
              await addBookmark(category.bookmarks[j], false);
            }
          }
        }
        refresh();
        resolve(remoteCategories);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * @description: 同步到服务端
 * @return {*}
 */
export const syncToServer = () => {
  return new Promise(async (resolve, reject) => {
    if (!user.token) {
      reject({ msg: '登录后同步' });
      return;
    }

    console.log('syncToServer');
    const categories = await getCategories();
    categories.sort((a, b) => {
      return a.order - b.order;
    });
    const objCategories = {};
    categories.forEach((element) => {
      objCategories[element.uuid] = element;
      element.bookmarks = [];
    });

    const bookmarkList = await getBookmarks();
    bookmarkList.sort((a, b) => {
      return a.order - b.order;
    });

    bookmarkList.forEach((element) => {
      const cat = objCategories[element.category_uuid];
      if (cat) {
        cat.bookmarks.push(element);
      }
    });

    const deleteBmArr = (await getLog('deleteBmArr'))?.data ?? [];
    const deleteCatArr = (await getLog('deleteCatArr'))?.data ?? [];
    http
      .post(`${urlPrefix}syncOnetab`, {
        list: categories,
        deleteBmArr,
        deleteCatArr,
      })
      .then((res) => {
        if (res.data.code === 200) {
          const logStore = Database.db
            .transaction(Database.storeNames.logs, 'readwrite')
            .objectStore(Database.storeNames.logs);
          logStore.put({ type: 'deleteBmArr', data: [] });
          logStore.put({ type: 'deleteCatArr', data: [] });
          resolve(res);
          console.log('syncOnetab success');
        } else {
          reject(res);
          console.log('syncOnetab failed');
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/**
 * @description: 根据url获取icon
 * @param {string} url
 * @return {*}
 */
export const getFaviconByUrl = (url: string) => {
  return http.get(`${urlPrefix}getFavicon?url=${url}`);
};

/**
 * @description: 图标库
 * @param {IKeyValue} data
 * @return {*}
 */
export const getIcons = (data: IKeyValue = {}) => {
  return http.get(
    `onetab/icon?type_id=${data.type_id}${
      data.name ? `&name=${data.name}` : ''
    }&page=${data.page}&size=${data.size}`
  );
};

/**
 * @description: 代理接口
 * @param {IKeyValue} data
 * @return {*}
 */
export const requestProxy = (data: IKeyValue) => {
  return http.post(`${urlPrefix}requestProxy`, {
    ...data,
  });
};
/**
 * @name:
 * @description: 最新发现
 * @msg:
 * @return {*}
 */
export const getNewFinds = (data: IKeyValue = { page: 1, size: 28 }) => {
  return http.get(`onetab/recommend/icon?page=${data.page}&size=${data.size}`);
};
/**
 * @name:
 * @description: 图标分类
 * @msg:
 * @return {*}
 */
export const getIconTypes = () => {
  return http.get(`onetab/icontype`);
};
export const getSearchIcons = (data) => {
  return http.get(
    `https://dwh_api.bimcc.net/api/onetab/search/icon?${
      data.name ? `name=${data.name}` : ''
    }`
  );
};
export const getVipTypes = () => {
  return http.get(`${urlPrefix}vip/list`);
};

export const removeShareCategory = (data) => {
  return new Promise((resolve, reject) => {
    const request = Database.db
      .transaction(Database.storeNames.categories, 'readwrite')
      .objectStore(Database.storeNames.categories)
      .delete(data.category_uuid);

    if (user.token) {
      http
        .post(`${urlPrefix}removeShareCategory`, {
          ...data,
        })
        .then((res) => {
          if (res.data.code === 200) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      resolve({ data: { code: 200 } });
    }
  });
};

export const getShareCodeByCategory = (data) => {
  return http.post(`${urlPrefix}getShareCodeByCategory`, {
    ...data,
  });
};

export const addShareCode = (data) => {
  return http.post(`${urlPrefix}inputShareCode`, {
    ...data,
  });
};

export const getDefaultIcons = () => {
  return http.get('onetab/getDefaultIcons');
};
export const getCategoryList = () => {
  return http.get('onetab/categories');
};
export const createShares = (data) => {
  return http.post('onetab/shares', { ...data });
};
export const getShareDetail = (code) => {
  return http.get(`onetab/shares/${code}`);
};
export const getSharesList = () => {
  return http.get(`onetab/shares`);
};
export const deleteShare = (id) => {
  return http.delete(`onetab/shares/${id}`);
};
